import React from 'react';
import { render } from 'react-dom';
import { BrowserRouter } from 'react-router-dom';

import { ContextProvider } from '../src/index';
import '@carta/ink/dist/ink.css';

import App from './App';

render(
  <div className={process.env.NODE_ENV === 'development' ? 'environment-debug' : ''}>
    <BrowserRouter>
      <ContextProvider>
        <App />
      </ContextProvider>
    </BrowserRouter>
  </div>,
  document.getElementById('root'),
);
